import { createContext } from 'react';

const ToggleThemeContext = createContext<VoidFunction>(() => void 0);

export default ToggleThemeContext;
